import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-laft-tab-stepper',
  templateUrl: './laft-tab-stepper.component.html',
  styleUrls: ['./laft-tab-stepper.component.scss'],
})
export class LaftTabStepperComponent implements OnInit {
  @Input() currentStepIndex: number;
  @Input() totalSteps: number;

  steps = [];

  ngOnInit(): void {
    this.steps = Array.from({ length: this.totalSteps }, (v, k) => k + 1);
  }
}
